// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const membershipRuleSchema = z.object({
  "group_id": z.string(),
  "expression": z.string(),
  "status": z.enum(["draft", "active", "paused"]),
  "eligibility_error": z.string().optional(),
  "activated_at": z.string().datetime({ offset: true }).nullable().optional(),
  "last_evaluated_at": z.string().datetime({ offset: true }).nullable().optional(),
  "last_reconciled_at": z.string().datetime({ offset: true }).nullable().optional(),
  "last_drift_count": z.number().int(),
  "created_at": z.string().datetime({ offset: true }),
  "updated_at": z.string().datetime({ offset: true })
});

export const membershipRulesSchema = z.object({
  "data": z.array(z.object({
    "group_name": z.string(),
    "rule": membershipRuleSchema
  })),
  "next_cursor": z.string().uuid().nullable()
});
